// extracted by mini-css-extract-plugin
export var iconContainer = "_g8-0";
export var metricCardsContainer = "_g8-1";